/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Generals, NavigationIcons } from '../../enums/general.names.enum';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { notify } from '../functions/react-toastify.function';
import { logout } from '../functions/log_out.function';
import { useBackdrop } from './backDrop_context.component';
import { HomePathLeftBarComponent } from './home_path_left_bar_component';
import { AccessControlLeftBart } from './access_control_left_bar_path.component';
import { PartnerNetworkLeftBarPath } from './partner_network_left_bar_path.component';
import { NetworkMonitoringLeftBarPath } from './network_monitoring_left_bar_path.component';
import { InventoryLeftBarPath } from './inventory_left_bar_path.component';
import { InvoiceManagementLeftBarPath } from './invoice_management_left_bar_path.component';
import { DataAnalyticsLeftBar } from './data_analytics_left_bar_path.component';
import {
  hasNetworkMonitoringPermissions,
  hasAnyPermission,
  PARTNER_NETWORK_PERMISSIONS,
  RING_PLANNING_PERMISSIONS,
  KMZ_PERMISSIONS,
  FIBER_POP_LIST_PERMISSIONS,
} from '../functions/permission_utils.function';

export const MianNavBarLeft = (props) => {
  const { handleReset, handleDrawerClose } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { showBackdrop, hideBackdrop } = useBackdrop();

  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];
  // Get the last part of the path
  const pathName = location.pathname.split('/').pop();

  // Check if current route is inventory-related (any child route)
  const isInventoryRoute =
    location.pathname.includes('/inventory') ||
    location.pathname.includes('/oko/fiberSite') ||
    location.pathname.includes('/oko/randb') ||
    location.pathname.includes('/leasedFiber') ||
    location.pathname.includes('/networkLayer');

  // Check if current route is network planning-related (any child route)
  const isNetworkPlanningRoute =
    location.pathname.includes('/kmzMap') ||
    location.pathname.includes('/kmz') ||
    location.pathname.includes('/networkPlanning/kmzPlanning') ||
    location.pathname.includes('/networkPlanning/ringPlanning') ||
    location.pathname.includes('/networkPlanning/fiberPopList');

  // Check if current route is invoice management-related (any child route)
  const isInvoiceManagementRoute =
    location.pathname.includes('/purchaseOrderManagement') ||
    location.pathname.includes('/poWorkflowManagement') ||
    location.pathname.includes('/invoiceAttachmentManagement') ||
    location.pathname.includes('/approvalPersonsInvoiceManagement') ||
    location.pathname.includes('/vendorInvoiceManagement') ||
    location.pathname.includes('/systemInvoiceManagementVendor');

  const isSystemInvoiceManagementRoute =
    location.pathname.includes('/systemPurchaseOrderManagement') ||
    location.pathname.includes('/systemPoWorkflowManagement') ||
    location.pathname.includes('/approvalPersonsSystemInvoiceManagement');

  const activeItemStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: `rgba(189, 29, 35, 0.10)`,
    borderRadius: '6px',
    cursor: 'pointer',
    marginBottom: '16px',
    marginTop: '16px',
  };

  const iconStyle = {
    width: '20px',
    height: '20px',
    marginBottom: '16px',
    marginTop: '16px',
    cursor: 'pointer',
  };
  const [selectedIcon, setSelectedIcon] = useState(null);

  // Function to handle icon click
  const handleIconClick = (iconIndex, name) => {
    setSelectedIcon(iconIndex);
    if (name === Generals.userManagement) {
      setSelectedIcon(NavigationIcons.USER_MANAGEMENT);
      navigate('/userManagement');
    }
    if (name === 'Partner Network') {
      setSelectedIcon(NavigationIcons.PARTNER_NETWORK);
      navigate('/kmzMap');
      return;
    }
    if (name === 'Ring Planning') {
      setSelectedIcon(NavigationIcons.PARTNER_NETWORK); // Use same icon as Partner Network
      navigate('/networkPlanning/ringPlanning');
      return;
    }
    if (name === 'KMZ') {
      setSelectedIcon(NavigationIcons.PARTNER_NETWORK); // Use same icon as Partner Network
      navigate('/networkPlanning/kmzPlanning');
      return;
    }
    if (name === 'Fiber Pop List') {
      setSelectedIcon(NavigationIcons.PARTNER_NETWORK); // Use same icon as Partner Network
      navigate('/networkPlanning/fiberPopList');
      return;
    }
    if (name === 'Network Monitoring') {
      setSelectedIcon(NavigationIcons.NETWORK_MONITORING);
      navigate('/fibers');
      return;
    }
    if (name === 'Inventory Management') {
      setSelectedIcon(NavigationIcons.INVENTORY);
      navigate('/inventory');
      return;
    }
    if (name === 'Invoice Management') {
      setSelectedIcon(NavigationIcons.INVOICE_MANAGEMENT);
      // Check which permission user has and navigate accordingly
      if (permissionNames.includes('Admin Invoice Management')) {
        navigate('/purchaseOrderManagement');
      } else if (permissionNames.includes('Approval Persons Invoice Management')) {
        navigate('/approvalPersonsInvoiceManagement');
      } else if (permissionNames.includes('Vendor Invoice Management')) {
        navigate('/vendorInvoiceManagement');
      } else if (permissionNames.includes('System Invoice Management Vendor')) {
        navigate('/systemInvoiceManagementVendor');
      }
      return;
    }

    if (name === 'System Invoice Management') {
      setSelectedIcon(NavigationIcons.INVOICE_MANAGEMENT);
      if (permissionNames.includes('System Invoice Management')) {
        navigate('/systemPurchaseOrderManagement');
      }
      return;
    }
    if (pathName === 'fibers') {
      if (typeof handleReset === 'function') {
        handleReset();
      }
      handleDrawerClose && handleDrawerClose();
    }
  };
  useEffect(() => {
    if (typeof handleReset === 'function') {
      handleReset();
    }
  }, [selectedIcon]);
  useEffect(() => {
    if (pathName === 'userManagement') {
      return setSelectedIcon(NavigationIcons.USER_MANAGEMENT);
    }
    if (pathName === 'kmzMap') {
      return setSelectedIcon(NavigationIcons.PARTNER_NETWORK);
    }
    if (pathName === 'ringPlanning') {
      return setSelectedIcon(NavigationIcons.PARTNER_NETWORK);
    }
    if (pathName === 'kmzPlanning') {
      return setSelectedIcon(NavigationIcons.PARTNER_NETWORK);
    }
    if (pathName === 'routePlanning' || pathName === 'leasingDeployment') {
      return setSelectedIcon(NavigationIcons.BUSINESS_INTELLIGENCE);
    }
    if (pathName === 'fibers') {
      return setSelectedIcon(NavigationIcons.NETWORK_MONITORING);
    }
    if (isInventoryRoute) {
      return setSelectedIcon(NavigationIcons.INVENTORY);
    }
    if (isNetworkPlanningRoute) {
      return setSelectedIcon(NavigationIcons.PARTNER_NETWORK);
    }
    if (
      pathName === 'approvalPersonsInvoiceManagement' ||
      pathName === 'vendorInvoiceManagement' ||
      pathName === 'systemInvoiceManagementVendor'
    ) {
      return setSelectedIcon(NavigationIcons.INVOICE_MANAGEMENT);
    }
    if (isInvoiceManagementRoute) {
      return setSelectedIcon(NavigationIcons.INVOICE_MANAGEMENT);
    }
    if (isSystemInvoiceManagementRoute) {
      return setSelectedIcon(NavigationIcons.INVOICE_MANAGEMENT);
    }
  }, [
    pathName,
    isInventoryRoute,
    isNetworkPlanningRoute,
    isInvoiceManagementRoute,
    isSystemInvoiceManagementRoute,
  ]);

  useEffect(() => {
    const handleTabSelectionChange = (event) => {
      const { iconIndex } = event.detail;
      console.log('Tab selection changed event received:', event.detail);
      setSelectedIcon(iconIndex);
    };

    window.addEventListener('tabSelectionChanged', handleTabSelectionChange);

    return () => {
      window.removeEventListener('tabSelectionChanged', handleTabSelectionChange);
    };
  }, []);
  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center">
        <HomePathLeftBarComponent />
        {permissionNames.includes('User Management') && (
          <AccessControlLeftBart
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
        {hasAnyPermission(
          permissionNames,
          [
            PARTNER_NETWORK_PERMISSIONS,
            KMZ_PERMISSIONS,
            RING_PLANNING_PERMISSIONS,
            FIBER_POP_LIST_PERMISSIONS,
          ].flat()
        ) && (
          <PartnerNetworkLeftBarPath
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
        {hasNetworkMonitoringPermissions(permissionNames) && (
          <NetworkMonitoringLeftBarPath
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
        {/* Inventory Management Icon */}
        {(permissionNames.includes('Inventory') ||
          permissionNames.includes('ranDb') ||
          permissionNames.includes('fiberSite') ||
          permissionNames.includes('Leased Fiber Pair') ||
          permissionNames.includes('Network Layer Visualization')) && (
          <InventoryLeftBarPath
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
        {permissionNames.includes('Da') && (
          <DataAnalyticsLeftBar
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
        {(permissionNames.includes('Admin Invoice Management') ||
          permissionNames.includes('System Invoice Management') ||
          permissionNames.includes('Approval Persons Invoice Management') ||
          permissionNames.includes('Vendor Invoice Management') ||
          permissionNames.includes('System Invoice Management Vendor')) && (
          <InvoiceManagementLeftBarPath
            selectedIcon={selectedIcon}
            activeItemStyle={activeItemStyle}
            iconStyle={iconStyle}
            handleIconClick={handleIconClick}
          />
        )}
      </Box>
    </>
  );
};
